export const failureHash = {
    AUTHENTICATION_ERROR: "API__EP__USERS__AUTHENTICATION_ERROR",
    AUTHORIZATION_ERROR: "API__EP__USERS__AUTHORIZATION_ERROR",
    CODE_INVALID: "API__EP__USERS__CODE_INVALID",
    CODE_PROCESS_THROTTLED: "API__EP__USERS__CODE_PROCESS_THROTTLED",
    CODE_SEND_THROTTLED: "API__EP__USERS__CODE_SEND_THROTTLED",
    EMAIL_ALREADY_VERIFIED: "API__EP__USERS__EMAIL_ALREADY_VERIFIED",
    EMAIL_NOT_FOUND: "API__EP__USERS__EMAIL_NOT_FOUND",
    PASSWORD_INVALID: "API__EP__USERS__PASSWORD_INVALID",
    PASSWORD_UNCHANGED: "API__EP__USERS__PASSWORD_UNCHANGED",
    RECAPTCHA_INVALID_INPUT_RESPONSE: "API__EP__USERS__RECAPTCHA_INVALID_INPUT_RESPONSE",
    RECAPTCHA_INVALID_INPUT_SECRET: "API__EP__USERS__RECAPTCHA_INVALID_INPUT_SECRET",
    RECAPTCHA_INVALID_OR_MALFORMED: "API__EP__USERS__RECAPTCHA_INVALID_OR_MALFORMED",
    RECAPTCHA_LOW_SCORE: "API__EP__USERS__RECAPTCHA_LOW_SCORE",
    RECAPTCHA_TIMEOUT_OR_DUPLICATE: "API__EP__USERS__RECAPTCHA_TIMEOUT_OR_DUPLICATE",
    THROTTLED: "API__EP__USERS__THROTTLED",
    UNKNOWN: "API__EP__USERS__UNKNOWN", // An unknown error has occured.
};
//# sourceMappingURL=user.static.js.map